enum Routes {
  HOME = "",
  SCREEN = ":slug?",
  NOT_FOUND = "not-found",
}

export { Routes };
